import { IColumn, Icon } from "office-ui-fabric-react";
import { Product, Template } from "typings";
import * as H from "history";
import { ParentElement, MainProductLink, StatusStyleNew, StatusStyleReady, StatusStyleWait } from "../products.style";
import * as React from "react";
import styled from "styled-components";
import * as G from "~/components/global.style";

export const getListSettings = (products: Product[], templates: Template[], history: H.History): IColumn[] =>
{
    const navigateToProductGroup = (productGroupId: string) => (e: React.MouseEvent<HTMLAnchorElement>) =>
    {
        e.preventDefault();
        history.push("/products/" + productGroupId);
        return false;
    };

    const onNavigateToProductClick = (id: string) => () => navigateToProduct(id);

    const  navigateToProduct = (id: string) =>  history.push(`/products/edit/${id}`); 
    
    return [
        {
            key: "column1", name: "Product Id", fieldName: "data.sku.value", minWidth: 20, maxWidth: 120, isResizable: true,
            onRender: (item: Product) =>
            {
                if (item.data && item.data.sku)
                {
                    return <span>{item.data.sku.value}</span>;
                }
                return <span></span>;
            }
        },
        { key: "column2", name: "name", minWidth: 1, isResizable: true,
        onRender: (item: Product) => 
        {
            if (item.data && item.data.itemName)
            {
                const keys = Object.keys(item.data.itemName.value);
                if (keys.length > 0)
                {
                    return <span>{item.data.itemName.value[keys[0]]}</span>;
                }
               
            }
            return <span></span>;
        },
        },
        { key: "column3", name: "Product data template", minWidth: 120, maxWidth: 120, isResizable: true, onRender: (product: Product) =>
        {
            if (product.type)
            {
                const template = templates.find(x => x.id === product.type);
                if (template)
                {
                    return <span>{template.label._DEFAULT}</span>;
                }
            }
            return null;
          
        }},
        { key: "column5", name: "Status", fieldName: "status", minWidth: 50, maxWidth:100, isResizable: true, onRender: (product: Product) =>
            {
                if (product.status === 1)
                {
                    return  <StatusStyleWait><Icon iconName="LocationDot" className={"ms-Dot-" + product.status} /></StatusStyleWait>;
                }
                if (product.status === 16)
                {
                    return  <StatusStyleReady><Icon iconName="LocationDot" className={"ms-Dot-" + product.status} /></StatusStyleReady>;
                }
                return  <StatusStyleNew><Icon iconName="LocationDot" className="ms-Dot" /></StatusStyleNew>;
            }
         },
        { key: "Assigned", name: "Assigned", fieldName: "assigned", isResizable: true,  minWidth: 100, maxWidth: 100, 
        onRender: (product: Product) =>
        {            
            if (product.parentId)
            {
                const parentProduct = products.find(x => x.id === product.parentId);
                let id =  product.parentId;
                if (parentProduct && parentProduct.data.itemName)
                {
                    const keys = Object.keys(parentProduct.data.itemName.value);
                    if (keys.length > 0)
                    {
                        id = parentProduct.data.itemName.value[keys[0]];
                    }
                }
                return (
                    <IconStyle><ParentElement >
                        <Icon 
                            onClick={onNavigateToProductClick(product.parentId)} iconName="Link" className="ms-Edit" title="Edit" 
                        />
                        <p>{id}</p>
                    </ParentElement></IconStyle>
                );
                
            }
            const hasChildren = products.find(x => x.parentId === product.id) !== undefined;
            if (hasChildren)
            {
                return (
                    <IconStyle>
                        <MainProductLink>
                            <Icon iconName="SplitObject" className="ms-SplitObject"  />
                            <a href="#" onClick={navigateToProductGroup(product.id)}>View variants</a>
                        </MainProductLink>
                    </IconStyle>
                );
            }
            return null;
          
        }
        },
        { key: "edit", name: " ", fieldName: "edit", minWidth: 46, maxWidth: 100, isResizable: true,  
            onRender: (product: Product) =>
            {
                const iconEdit =  <Icon iconName="SingleColumnEdit" className="ms-Edit" title="Edit" />;
                // tslint:disable-next-line:react-this-binding-issue
                return <IconStyle onClick={() => navigateToProduct(product.id)} >{iconEdit} Edit</IconStyle>;
            }
        }

    ];
};


export const IconStyle = styled.div`
    color: ${G.PrimaryColor};
    display: flex;
    cursor: pointer;
    a{
        color: ${G.PrimaryColor};
    }
    .ms-Edit{
        font-size: 18px;
        
    }

    [data-icon-name="SingleColumnEdit"]{
        margin-right: 5px;
    }
`;


// WEBPACK FOOTER //
// ./src/components/product/productList/ListSetting.tsx